export const restrictedSideBarUrl = ['/resources', '/admin/marketplace/link'];
